export default __webpack_public_path__ + "static/media/home.dd2647cd.svg";